import { ARCHIVED_CHEST_TEACHINGS } from './archived-chest-teachings';
import { ARCHIVED_BACK_TEACHINGS } from './archived-back-teachings';
import { ARCHIVED_SHOULDERS_TEACHINGS } from './archived-shoulders-teachings';
import { ARCHIVED_ARMS_TEACHINGS } from './archived-arms-teachings';
import { ARCHIVED_LEGS_TEACHINGS } from './archived-legs-teachings';
import { ARCHIVED_ABS_TEACHINGS } from './archived-abs-teachings';
import { ARCHIVED_WARMUP_TEACHINGS } from './archived-warmup-teachings';
import { ARCHIVED_STRETCH_TEACHINGS } from './archived-stretch-teachings';
import type { IExercise } from '../exercises';

const materials = new Map([
  ...ARCHIVED_CHEST_TEACHINGS,
  ...ARCHIVED_BACK_TEACHINGS,
  ...ARCHIVED_SHOULDERS_TEACHINGS,
  ...ARCHIVED_ARMS_TEACHINGS,
  ...ARCHIVED_LEGS_TEACHINGS,
  ...ARCHIVED_ABS_TEACHINGS,
  ...ARCHIVED_WARMUP_TEACHINGS,
  ...ARCHIVED_STRETCH_TEACHINGS,
].map(exercise => [exercise.id, exercise]));

/** Stable original ordering and media keep old plans and protected courses resolvable. */
export const ARCHIVED_EXERCISE_MATERIALS: IExercise[] = [
  materials.get("band-shoulder-warmup")!,
  materials.get("barbell-flat-press")!,
  materials.get("cable-crossover")!,
  materials.get("incline-bench-row")!,
  materials.get("barbell-bicep-curl")!,
  materials.get("kneel-tricep-dip")!,
  materials.get("wall-scapular-protraction")!,
  materials.get("hip-adductor-machine")!,
  materials.get("side-lying-hip-adduct")!,
  materials.get("side-lunge-stretch")!,
  materials.get("bulgarian-split-squat")!,
  materials.get("single-leg-dumbbell-dl")!,
  materials.get("dumbbell-lunge")!,
  materials.get("standing-calf-raise")!,
  materials.get("supine-cable-tricep")!,
  materials.get("prone-dumbbell-fly")!,
  materials.get("push-up")!,
  materials.get("single-leg-dl-glute")!,
  materials.get("seated-cable-curl")!,
  materials.get("band-shoulder-pull")!,
  materials.get("cable-face-pull")!,
  materials.get("behind-neck-cable-tricep")!,
  materials.get("home-prone-reverse-fly")!,
  materials.get("home-bent-tricep-kickback")!,
  materials.get("home-dumbbell-pushup")!,
  materials.get("home-dumbbell-flat-press")!,
  materials.get("home-dumbbell-fly")!,
  materials.get("home-seated-behind-neck-tricep")!,
  materials.get("home-band-chest-activate")!,
  materials.get("home-wall-handstand")!,
  materials.get("home-prone-back-extension")!,
  materials.get("home-single-arm-dumbbell-row")!,
  materials.get("home-double-dumbbell-bent-row")!,
  materials.get("home-dumbbell-curl")!,
  materials.get("home-pull-up")!,
  materials.get("home-worlds-greatest-stretch")!,
  materials.get("home-side-plank-v2")!,
  materials.get("home-bulgarian-split-squat-v2")!,
  materials.get("home-glute-bridge-v2")!,
  materials.get("home-goblet-squat")!,
  materials.get("home-prone-y-raise")!,
  materials.get("home-seated-dumbbell-rear-fly")!,
  materials.get("home-seated-dumbbell-press")!,
  materials.get("ksw-chest-bench-press-compressed")!,
  materials.get("ksw-dips")!,
  materials.get("ksw-lying-extension")!,
  materials.get("ksw-y-raise")!,
  materials.get("ksw-warmup-pec-minor-release")!,
  materials.get("ksw-warmup-pec-major-release")!,
  materials.get("ksw-warmup-biceps-release")!,
  materials.get("ksw-warmup-lower-trap-y")!,
  materials.get("ksw-warmup-serratus-activation")!,
  materials.get("ksw-warmup-wrist-activation")!,
  materials.get("ksw-single-arm-cable-pulldown")!,
  materials.get("ksw-single-arm-machine-row")!,
  materials.get("ksw-wide-grip-row")!,
  materials.get("ksw-cable-curl")!,
  materials.get("ksw-warmup-band-shoulder-circles")!,
  materials.get("ksw-warmup-thoracic-flexion")!,
  materials.get("ksw-warmup-thoracic-proprioception")!,
  materials.get("ksw-single-leg-bulgarian")!,
  materials.get("ksw-barbell-rdl")!,
  materials.get("ksw-back-extension")!,
  materials.get("ksw-warmup-dynamic-frog")!,
  materials.get("ksw-warmup-hip-90-90")!,
  materials.get("ksw-warmup-ankle-activation")!,
  materials.get("ksw-warmup-foam-calf")!,
  materials.get("ksw-warmup-foam-quad")!,
  materials.get("ksw-warmup-foam-glute")!,
  materials.get("ksw-warmup-foam-tfl")!,
  materials.get("ksw-warmup-foam-tibialis")!,
  materials.get("threeway-shoulder-warmup")!,
  materials.get("threeway-machine-fly")!,
  materials.get("threeway-flat-machine-press")!,
  materials.get("threeway-dips")!,
  materials.get("threeway-decline-cable-fly")!,
  materials.get("threeway-lateral-raise")!,
  materials.get("threeway-behind-neck-tricep")!,
  materials.get("threeway-back-warmup")!,
  materials.get("threeway-neutral-pulldown")!,
  materials.get("threeway-supinated-pulldown")!,
  materials.get("threeway-narrow-cable-row")!,
  materials.get("threeway-tbar-row")!,
  materials.get("threeway-seated-reverse-fly")!,
  materials.get("threeway-cable-reverse-fly")!,
  materials.get("threeway-bench-dip")!,
  materials.get("threeway-barbell-skull-crusher")!,
  materials.get("threeway-dumbbell-shoulder-activation")!,
  materials.get("threeway-smith-press")!,
  materials.get("threeway-bent-barbell-row")!,
  materials.get("threeway-lying-leg-curl")!,
  materials.get("threeway-rhino-squat")!,
  materials.get("threeway-bulgarian-squat")!,
  materials.get("personal-s1-chest-stretch")!,
  materials.get("personal-s1-posterior-delt-stretch")!,
  materials.get("personal-s1-anterior-delt-stretch")!,
  materials.get("personal-s1-back-tricep-stretch")!,
  materials.get("personal-s1-rhomboid-stretch")!,
  materials.get("personal-s1-bicep-stretch")!,
  materials.get("personal-s1-abs-oblique-stretch")!,
  materials.get("personal-s1-glute-stretch")!,
  materials.get("personal-s1-hamstring-stretch")!,
  materials.get("personal-s1-quad-stretch")!,
  materials.get("personal-s1-calf-stretch")!,
  materials.get("personal-s1-levator-scap-stretch")!,
  materials.get("personal-s1-sternocleidomastoid")!,
  materials.get("personal-s1-scalene-release")!,
  materials.get("personal-s1-platysma-stretch")!,
  materials.get("personal-s2-prep")!,
  materials.get("personal-s2-ab-wheel-foam")!,
  materials.get("personal-s2-straight-arm-pulldown")!,
  materials.get("personal-s2-single-arm-cable-row")!,
  materials.get("personal-s2-cable-tricep-pushdown")!,
  materials.get("personal-s2-cable-reverse-fly")!,
  materials.get("personal-s3-supine-dumbbell-curl")!,
  materials.get("personal-s3-overhead-tricep")!,
  materials.get("personal-s3-internal-rotation-curl")!,
  materials.get("personal-s4-seated-flat-press")!,
  materials.get("personal-s4-cable-upper-chest")!,
  materials.get("personal-s4-shoulder-work")!,
  materials.get("personal-s5-trx-activation")!,
  materials.get("personal-s5-bent-over-rear-delt")!,
  materials.get("personal-s5-dumbbell-shoulder-press")!,
  materials.get("personal-s5-lateral-raise")!,
  materials.get("personal-s6-adductor")!,
  materials.get("personal-s6-bulgarian-squat")!,
  materials.get("personal-s6-dumbbell-rdl")!,
  materials.get("personal-s6-hip-flexor-raise")!,
  materials.get("personal-s7-hanging-leg-raise")!,
  materials.get("personal-s7-crunch")!,
  materials.get("personal-s7-ab-wheel")!,
  materials.get("personal-s8-cable-tricep-pushdown")!,
  materials.get("personal-s8-barbell-supine-standing")!,
  materials.get("fanjue-scapular-activation")!,
  materials.get("fanjue-standing-chest-shoulder-stretch")!,
  materials.get("fanjue-wide-pulldown")!,
  materials.get("fanjue-straight-arm-pulldown")!,
  materials.get("fanjue-prone-machine-row")!,
  materials.get("fanjue-supinated-straight-arm-pulldown")!,
  materials.get("fanjue-seated-machine-row")!,
  materials.get("fanjue-lat-pulldown")!,
  materials.get("fanjue-elbow-bench-stretch")!,
  materials.get("fanjue-spider-warmup")!,
  materials.get("fanjue-seated-cable-row")!,
  materials.get("fanjue-bulgarian-squat")!,
  materials.get("fanjue-external-rotation-press")!,
  materials.get("fanjue-head-ground-press")!,
  materials.get("fanjue-stretch-counter")!,
  materials.get("fanjue-foam-roller-support")!,
  materials.get("fanjue-rear-delt-bodyweight")!,
  materials.get("fanjue-internal-rotation-activation")!,
  materials.get("fanjue-elbow-extension-tricep")!,
  materials.get("fanjue-kneeling-pushup")!,
  materials.get("fanjue-incline-barbell-press")!,
  materials.get("fanjue-supine-face-pull")!,
  materials.get("fanjue-rotator-cuff-activation")!,
  materials.get("fanjue-standing-military-press")!,
  materials.get("fanjue-chest-warmup")!,
  materials.get("fanjue-incline-smith-press")!,
  materials.get("fanjue-incline-machine-chest-press")!,
  materials.get("fanjue-dumbbell-front-raise")!,
  materials.get("fanjue-reverse-hyperextension-crunch")!,
  materials.get("fanjue-cable-crunch-kneeling")!,
  materials.get("fanjue-bent-barbell-curl")!,
  materials.get("fanjue-single-arm-cable-tricep")!,
  materials.get("fanjue-straight-bar-tricep")!,
  materials.get("fanjue-cable-hammer-curl")!,
  materials.get("fanjue-side-band-walk")!,
  materials.get("fanjue-gluteus-minimus-activation")!,
  materials.get("fanjue-bulgarian-glute")!,
  materials.get("fanjue-copenhagen-plank")!,
  materials.get("fanjue-wide-body-function")!,
  materials.get("fanjue-cable-twist")!,
  materials.get("fanjue-leg-warmup")!,
  materials.get("fanjue-bulgarian-leg")!,
  materials.get("fanjue-seated-leg-extension")!,
];
